import type { JSX } from 'react';
import type { WireChatMessage } from '@logistics/contracts';

/**
 * The person's question: right-aligned, in the soft accent, with any files it
 * carried. `onSchedule`, for an admin, turns a question that answered well
 * into a scheduled prompt.
 */
export function UserMessage({
  message,
  onSchedule,
}: {
  message: WireChatMessage;
  onSchedule?: (() => void) | undefined;
}): JSX.Element {
  return (
    <div className="group flex animate-[rise_.3s_ease_both] flex-col items-end gap-2">
      <div className="bg-acc-soft text-ink max-w-[72%] rounded-[14px_14px_4px_14px] border border-[color-mix(in_oklch,var(--acc)_30%,transparent)] px-[15px] py-[11px] text-sm leading-normal whitespace-pre-wrap [overflow-wrap:anywhere]">
        {message.text}
        {message.attachments.length > 0 && (
          <div className="text-mute mt-1.5 font-mono text-[11px]">
            attached: {message.attachments.map((a) => a.name).join(', ')}
          </div>
        )}
      </div>
      {onSchedule !== undefined && (
        <button
          type="button"
          onClick={onSchedule}
          className="text-mute hover:text-acc bg-transparent p-0 font-mono text-[11px] opacity-0 transition-opacity group-hover:opacity-100 focus:opacity-100"
        >
          ⏰ Schedule this
        </button>
      )}
    </div>
  );
}
